import type { CustomIconProps } from '../types';

const RevertedLike = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '15'}
        viewBox="0 0 16 15"
        fill="none"
    >
        <path
            d="M8 0.150024L8.28235 0.385713C14.3529 5.33521 16 7.07932 16 9.9076C16 12.2645 14.1176 14.15 11.7647 14.15C9.83529 14.15 8.75294 13.0658 8 12.2174C7.24706 13.0658 6.16471 14.15 4.23529 14.15C1.88235 14.15 1.64838e-07 12.2645 3.70885e-07 9.9076C6.18141e-07 7.07932 1.64706 5.33521 7.71765 0.385713L8 0.150024ZM11.7647 13.2073C13.6 13.2073 15.0588 11.746 15.0588 9.9076C15.0588 7.50356 13.5529 5.90087 8 1.37561C2.44706 5.90087 0.941177 7.50356 0.941177 9.9076C0.941177 11.746 2.4 13.2073 4.23529 13.2073C5.88235 13.2073 6.77647 12.2174 7.48235 11.416L8 10.8032L8.51765 11.416C9.22353 12.2174 10.1176 13.2073 11.7647 13.2073Z"
            fill="#414042"
        />
    </svg>
);

export default RevertedLike;
